// Phase 4 Wave 0 — Hotwire + Stimulus + Chartkick + lucide boot
//
// Import order matters: chartkick/chart.js registers the Chart.js global before the
// date-fns adapter attaches to it (RESEARCH §Pitfall 4 — Chart.js 4.x requires an
// explicit date adapter for timestamp X-axes).
import "@hotwired/turbo-rails"
import "./controllers"
import "chartkick/chart.js"
import "chartjs-adapter-date-fns"

// UAT 2026-05-12 — Chart.js renders text directly to canvas with no CSS
// inheritance, so the default 'Helvetica/Arial/sans-serif' font lacks Korean
// glyphs and `온도`/`습도` legend labels become tofu boxes. Set the global
// default to the page font (Pretendard + system fallback) so every chart in
// the app picks it up — overrides via `library: { font: ... }` still work.
import { Chart } from "chart.js"
Chart.defaults.font.family =
  "'Pretendard Variable', 'Pretendard', system-ui, -apple-system, sans-serif"

// lucide — re-render `<i data-lucide="...">` icons on every Turbo navigation.
import { createIcons, icons } from "lucide"
document.addEventListener("turbo:load", () => createIcons({ icons }))
